module.exports = __webpack_public_path__ + "static/media/Camera05_background.37615d8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/desktop/Camera05_background.png
// module id = 985
// module chunks = 0